module.exports = __webpack_public_path__ + "assets/img/nobracelet.f9b443be.png";